import { render, staticRenderFns } from "./TeamTalkRoomComponent.vue?vue&type=template&id=480ab67e&"
import script from "./TeamTalkRoomComponent.vue?vue&type=script&lang=js&"
export * from "./TeamTalkRoomComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports